export default "__VITE_ASSET__ByKP8nk7__"